import { Injectable, Inject, Optional } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PershingLocaleService {
    defaultLocale: any = 'en';
    currentLocale: any = this.defaultLocale;
    constructor(@Optional() @Inject('AppSettings') private appSettings) {
        if (appSettings && appSettings.locale) {
            this.currentLocale = appSettings.locale;
        }
    }
    getCurrentLocale() {
        if (this.appSettings && this.appSettings.locale) {
            this.currentLocale = this.appSettings.locale;
        }
        return this.currentLocale;
    }
}
